import React, { lazy, Suspense } from "react";
import { FaCheck } from "react-icons/fa6";
import { Helmet } from "react-helmet-async";

const Whywaggexcommonchoice = lazy(
  () => import("./common/Whywaggexcommonchoice"),
);
const LookingforPayroll = lazy(() => import("./common/LookingforPayroll"));
const HomeFaq = lazy(() => import("../../pages/HomeFaq"));
const AppDownloadCard = lazy(() => import("../common/AppDownloadCard"));
const PayrollBanner = lazy(() => import("../common/PayrollBanner"));
const ModernizeHR = lazy(() => import("../common/ModernizeHR"));
import Img1 from "@/assets/citywise/waggex-payroll-software-hyderabad-hero-dashboard.webp?w=500&format=webp";

const Hyderabad = () => {
  const faq1 = [
    {
      title: "Which is the best payroll software in Hyderabad?",
      content:
        "The best payroll software depends on your business size and workforce requirements. Waggex helps Hyderabad businesses automate payroll processing, attendance tracking, leave management, payslip generation, and employee records from one centralized platform.",
    },
    {
      title: "Does Waggex support attendance-based payroll?",
      content:
        "Yes. Waggex automatically calculates salaries based on employee attendance, shifts, overtime, leaves, and working hours, helping businesses reduce payroll errors and save HR administration time.",
    },
    {
      title: "Can employees access payslips and leave records online?",
      content:
        "Yes. Employees can use the Waggex Staff App to view attendance records, download payslips, apply for leave, track leave balances, and receive important HR notifications anytime.",
    },
  ];

  const faq2 = [
    {
      title: "Does Waggex offer GPS and face recognition attendance?",
      content:
        "Yes. Waggex supports GPS attendance tracking, geofencing, AI selfie attendance, and face recognition attendance to help businesses prevent buddy punching and improve attendance accuracy.",
    },
    {
      title: "Which businesses can use Waggex payroll software?",
      content:
        "Waggex is suitable for startups, SMEs, IT companies, retail businesses, factories, agencies, consultancies, and field workforce teams looking to simplify payroll, attendance, and workforce management.",
    },
  ];

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Waggex",
      url: "https://www.waggex.com/best-payroll-software-in-hyderabad",

      image: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Best payroll software in Hyderabad for businesses and SMEs. Streamline payroll processing, attendance tracking, leave management, employee records, and workforce management.",

      applicationCategory: "BusinessApplication",

      operatingSystem: "Web, Android, iOS",

      featureList: [
        "Payroll software Hyderabad",
        "Attendance management software Hyderabad",
        "Leave and shift management Hyderabad",
        "Face recognition attendance Hyderabad",
        "Employee self-service app",
        "GPS attendance tracking",
        "Automated payroll processing",
        "AI selfie attendance",
      ],

      offers: {
        "@type": "Offer",
        priceCurrency: "INR",
        price: "0",
        description: "Free trial available",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        reviewCount: "250",
      },

      provider: {
        "@type": "Organization",
        name: "Waggex",
        url: "https://www.waggex.com/",
        logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

        areaServed: {
          "@type": "Country",
          name: "Hyderabad",
        },

        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+91-01724534553",
          email: "info@waggex.com",
          contactType: "customer support",
        },
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Which is the best payroll software in Hyderabad?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The best payroll software depends on your business size and workforce requirements. Waggex helps Hyderabad businesses automate payroll processing, attendance tracking, leave management, payslip generation, and employee records from one centralized platform.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex support attendance-based payroll?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex automatically calculates salaries based on employee attendance, shifts, overtime, leaves, and working hours, helping businesses reduce payroll errors and save HR administration time.",
          },
        },
        {
          "@type": "Question",
          name: "Can employees access payslips and leave records online?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Employees can use the Waggex Staff App to view attendance records, download payslips, apply for leave, track leave balances, and receive important HR notifications anytime.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex offer GPS and face recognition attendance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex supports GPS attendance tracking, geofencing, AI selfie attendance, and face recognition attendance to help businesses prevent buddy punching and improve attendance accuracy.",
          },
        },
        {
          "@type": "Question",
          name: "Which businesses can use Waggex payroll software?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Waggex is suitable for startups, SMEs, IT companies, retail businesses, factories, agencies, consultancies, and field workforce teams looking to simplify payroll, attendance, and workforce management.",
          },
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",

      name: "Waggex",

      url: "https://www.waggex.com/",

      logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Waggex provides payroll software, attendance management, leave management, HRMS, and workforce management solutions for businesses across India.",

      areaServed: {
        "@type": "Country",
        name: "India",
      },

      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+91-01724534553",
        email: "info@waggex.com",
        contactType: "customer support",
        availableLanguage: ["English", "Hindi"],
      },

      sameAs: ["https://www.linkedin.com/company/waggex"],
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.waggex.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Payroll Software Hyderabad",
          item: "https://www.waggex.com/best-payroll-software-in-hyderabad",
        },
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Best Payroll Software in Hyderabad for Businesses & SMEs | Waggex
        </title>
        <meta
          name="description"
          content="Looking for payroll software in Hyderabad? Waggex automates payroll, attendance, leave, and employee management for growing Hyderabad businesses. Book a free demo today"
        />
        <meta
          name="keywords"
          content="payroll software in Hyderabad,payroll software Hyderabad,HR software for businesses in Hyderabad,attendance management software Hyderabad,HRMS software Hyderabad,online payroll system Hyderabad,employee management software Hyderabad,leave management software Hyderabad,face recognition attendance Hyderabad,payroll software for IT companies Hyderabad,payroll software for pharma companies Hyderabad"
        />
        <link
          rel="canonical"
          href="https://www.waggex.com/best-payroll-software-in-hyderabad"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      </Helmet>
      <section className="w-full bg-[#d1dfea] overflow-hidden py-10 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-6 mb-20 mt-10">
            {/* Left Content */}
            <div className="text-center lg:text-left">
              {/* Heading */}
              <h1 className="text-[#10324F] font-bold uppercase tracking-wide text-xl md:text-2xl min-h-22">
                Best Payroll Software in Hyderabad for Businesses & Startups
              </h1>

              {/* Description */}
              <p className="service-list-item-text py-4 max-w-2xl mb-6">
                Managing payroll, attendance, leave requests, and employee
                records manually can be time-consuming and prone to errors.
                <strong> Waggex </strong> helps Hyderabad businesses automate
                payroll processing, attendance tracking, payslip generation, and
                workforce management from one centralized HRMS platform, saving
                time, improving accuracy, and reducing HR workload
              </p>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button
                  onClick={() =>
                    (window.location.href = "https://app.waggex.com/signup")
                  }
                  className="w-full sm:w-auto bg-[#10324F] hover:bg-[#10324F] transition-all duration-300 text-white px-14 py-3 rounded-xl shadow-md text-sm sm:text-base font-medium"
                >
                  Start Free Today
                </button>

                <button
                  onClick={() => (window.location.href = "/contact-us")}
                  className="w-full sm:w-auto border border-[#10324F] text-[#10324F] hover:bg-[#10324F] hover:text-white transition-all duration-300 px-14 py-3 rounded-xl text-sm sm:text-base font-medium"
                >
                  Book a Demo
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative flex justify-center items-center">
              <picture>
                <source media="(max-width: 639px)" srcSet={Img1} />
                <img
                  src={Img1}
                  fetchPriority="high"
                  width={500}
                  height={412}
                  loading="eager"
                  decoding="async"
                  alt="Waggex all-in-one payroll software Hyderabad showing payroll management, attendance management, employee management and payslip generation for growing businesses"
                  className="relative object-contain"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Run Payroll, Attendance & HR Operations from One Platform
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base leading-relaxed">
              Managing payroll, attendance, leave requests, and employee records
              manually can slow down daily operations and create unnecessary
              errors. <strong>Waggex </strong> helps Hyderabad businesses
              automate workforce management, improve payroll accuracy, and
              reduce HR workload from a single platform
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated Payroll Processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift Management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-Based Salary Calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>PDF Payslip Generation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Self-Service App</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Leave Management</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Face Recognition Attendance</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Automate Payroll Processing and Eliminate Manual HR Work
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Payroll mistakes, attendance mismatches, overtime calculations,
              and salary processing can consume valuable HR time every month.
              <strong> Waggex </strong> automates payroll calculations,
              attendance-based salary processing, payslip generation, and
              employee records management, helping Hyderabad businesses process
              payroll faster, improve accuracy, and reduce administrative
              workload
            </p>
            {/* <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Businesses across Delhi use <strong>Waggex</strong> to reduce
              manual work, centralize employee records, and process payroll with
              greater confidence every month
            </p> */}
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated payroll calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee salary reports</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based payroll processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payroll history and records</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Overtime and shift salary management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee payroll notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payslip generation in PDF format</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-3xl mx-auto leading-loose">
            From salary calculations to payslip delivery,
            <strong>Waggex </strong> streamlines the entire payroll process so
            HR teams can focus on people, not paperwork
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Track Employee Attendance Accurately with AI & GPS
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Managing attendance for office employees, field staff, remote
              teams, and shift workers can be challenging.{" "}
              <strong>Waggex </strong> combines AI attendance, GPS tracking,
              geofencing, face recognition, and mobile attendance tools in one
              platform, helping Hyderabad businesses improve accuracy, simplify
              payroll, and reduce manual HR work
            </p>
          </div>
          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift-Based Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mobile Attendance Marking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Geofencing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Attendance Reports</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>FaceLens AI Face Recognition Attendance</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Manage attendance, shifts, and payroll from a single platform while
            eliminating buddy punching, manual registers, and attendance
            discrepancies{" "}
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Simplify Leave Approvals and Shift Scheduling
            </h2>

            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Manage leave requests, approvals, shift schedules, and employee
              availability from one platform without manual follow-ups or
              spreadsheets
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Yearly leave allocation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave approval workflow</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave balance tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-time leave notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based leave management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift management</span>
              </div>
            </div>{" "}
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-2xl mx-auto leading-loose">
            Employees can apply for leave and view approvals instantly, while
            managers track requests and shifts from a centralized dashboard
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Give Employees Control, Save HR Time
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Employees can manage attendance, leave requests, payslips, and
              important updates directly from the
              <strong> Waggex Staff App</strong>, reducing routine HR queries
              and saving administrative time
            </p>
            <p className="mt-4 text-[#10324F] text-lg">Employee Can:</p>
          </div>
          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mark attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>View attendance history</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Apply for leave </span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Receive notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Download payslips</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Access employee records</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Fewer employee queries, faster approvals, and more time for HR to
            focus on business priorities
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Built for Businesses of Every Size and Industry
            </h2>

            <p className="mt-4 text-[#10324F] text-lg">
              Waggex is suitable for:
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Startups</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Factories</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>SMEs</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Service Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>IT Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Field Workforce Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Retail Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Agencies & Consultancies</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Suspense fallback={null}>
        <Whywaggexcommonchoice
          heading="Why Businesses Choose Waggex For Payroll & Workforce Management"
          description="Managing employee attendance, payroll processing, leave approvals, and workforce records shouldn't require spreadsheets and manual follow-ups. Waggex helps Hyderabad businesses automate routine HR tasks, improve payroll accuracy, and manage their entire workforce from one easy-to-use platform"
          paragraph=""
        />
        <LookingforPayroll
          heading="See How Waggex Can Save Hours of HR Work Every Month"
          subHeading="Book a Free Demo and Explore Waggex Features"
          description="Discover how Waggex automates payroll processing, attendance tracking, leave management, employee records, and compliance from one centralized platform"
          features={[
            "AI Attendance Management",
            "Payroll Automation",
            "Employee Self-Service App",
            "GPS & Face Recognition Attendance",
            "Attendance-Based Payroll",
            "Real-Time Notifications",
          ]}
          buttonText="Book Free Demo"
        />
        <HomeFaq
          faq1={faq1}
          faq2={faq2}
          subtitle="Everything you need to know about Waggex payroll software in India"
        />
        {/*  <AppDownloadCard /> */}
        <PayrollBanner
          heading="Ready to Automate Payroll, Attendance & HR?"
          description="See how Waggex helps businesses reduce manual work, improve payroll accuracy, and manage employees more efficiently with one easy-to-use platform"
          buttonText="View HRMS Software"
          buttonLink="https://waggex.com/"
        />
        <AppDownloadCard />
        <ModernizeHR />
      </Suspense>
    </>
  );
};

export default Hyderabad;
